import { create } from '@thoughtspot/logger';
import { DispatchChartInteractionUseCase, } from '@thoughtspot/ts-chart-sdk';
import { handleTriggerOnParent } from './trigger-event';
import { validateDispatchChartInteractionPayload } from './utils';
const logger = create('chart-to-ts > dispatch-chart-interaction');
export const getDispatchChartInteractionEventProcessor = (props) => {
    const { iFrameWindow } = props;
    const validateEventPayload = (eventData) => {
        const payload = eventData.payload;
        try {
            validateDispatchChartInteractionPayload(payload);
        }
        catch (err) {
            logger.warn(err);
            return {
                isValid: false,
                errors: [err.toString()],
            };
        }
        return {
            isValid: true,
        };
    };
    return {
        validateEventPayload,
        executeEvent: async (eventData) => {
            const payload = eventData.payload;
            const { type, useCases, eventPayload } = payload;
            useCases.forEach(useCase => {
                switch (useCase) {
                    case DispatchChartInteractionUseCase.TriggerOnParent:
                        console.log('TriggerOnParent', type, eventPayload);
                        handleTriggerOnParent(type, eventPayload, iFrameWindow);
                        break;
                    default:
                        logger.warn(`Unknown DispatchChartInteraction useCase: ${useCase}`);
                }
            });
            return Promise.resolve();
        },
    };
};
//# sourceMappingURL=index.js.map